import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from './theme-provider';
import { useTranslation } from '../context/LanguageContext';
import { useQuery } from '@tanstack/react-query';
import api from '../api/axios';
import { getMediaUrl } from '../utils/url';

export function SettingsSync() {
  const { user } = useAuth();
  const { setTheme } = useTheme();
  const { lang, setLang } = useTranslation();

  const hasSyncedThemeRef = useRef(false);

  useEffect(() => {
    if (!user) {
      hasSyncedThemeRef.current = false;
      return;
    }

    // Синхронизация темы удалена, так как она вызывала сброс темы при перезагрузке (опираемся только на localStorage)
    if (!hasSyncedThemeRef.current) {
      hasSyncedThemeRef.current = true;
    }

    // Синхронизация языка из профиля
    if (user.lang && user.lang !== lang && (user.lang === 'RU' || user.lang === 'UZ')) {
      setLang(user.lang as 'RU' | 'UZ');
    }
  }, [user, lang, setTheme, setLang]);

  // Fetch and sync global system settings (Branding)
  useQuery({
    queryKey: ['system-settings'],
    queryFn: async () => {
      try {
        const res = await api.get('/settings');
        const settings = Array.isArray(res.data) ? res.data : [];

        const companyNameSetting = settings.find((s: { key: string; value: string }) => s.key === 'COMPANY_NAME');
        const companyLogoSetting = settings.find((s: { key: string; value: string }) => s.key === 'COMPANY_LOGO');

        const companyName = companyNameSetting?.value || 'ERP Uzbekistan';
        const companyLogo = companyLogoSetting?.value || '';

        // Save to localStorage for GlobalLoader
        localStorage.setItem('COMPANY_NAME', companyName);
        if (companyLogo) {
          localStorage.setItem('COMPANY_LOGO', companyLogo);
        } else {
          localStorage.removeItem('COMPANY_LOGO');
        }

        // Update document <title>
        document.title = companyName;

        // Update Favicon
        let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }

        if (companyLogo) {
          link.href = getMediaUrl(companyLogo) as string;
        } else {
          link.href = '/favicon.png';
        }

        return settings;
      } catch (_err) {
        console.warn('System settings fetch failed');
        return [];
      }
    },
    staleTime: 60000,
    refetchOnWindowFocus: true,
  });

  return null;
}
